import i18n from "../plugins/i18n/i18n";
import { message } from "antd";


const getMinutesFromString = (stringMinute) => {
  let minute = stringMinute.split(":")[1];
  if (minute[0] === "0") {
    minute = minute.substring(1);
  }
  return parseInt(minute, 10);
};

const getHoursFromString = (stringHour) => {
  let hour = stringHour.split(":")[0];
  if (hour[0] === "0") {
    hour = hour.substring(1);
  }
  return parseInt(hour, 10);
};

const parseTimeSpanFromInteger = (Integer) => {
  if (Integer < 10) {
    return `00:0${Integer}:00`;
  } else {
    return `00:${Integer}:00`;
  }
};

const stringToDate = (timeString) => {
  if (timeString) {
    var timeArray = timeString.split(":");
    var date = new Date(1997, 3, 1, timeArray[0], timeArray[1]);
    return date;
  }
};

const dateToString = (date) => {
  if (date) {
    var hour = date.getHours();
    var minute = date.getMinutes();
    if (hour < 10) {
      hour = "0" + hour;
    }
    if (minute < 10) {
      minute = "0" + minute;
    }
    return hour + ":" + minute + ":00";
  }
};

const isMobile = () => {
  return document.querySelectorAll("body")[0].clientWidth <= 767;
};

const goOtherWeek = () => {
  let weekRows = document.getElementsByClassName("rc-calendar-tbody")[0]
    .children;
  for (let i = 0; i < weekRows.length; i++) {
    weekRows[i].style.display = "none";
  }
  document.getElementsByClassName(
    "rc-calendar-selected-date"
  )[0].parentNode.style.display = "table-row";
};
const lowerFirstLetter = (str) => {
  let firstLetter = str.charAt(0).toLowerCase();
  let remaining = str.substring(1, str.length);

  return firstLetter + remaining;
};

const getDuration = (duration, type) => {
  if (!type) {
    type = "short";
  }
  duration = duration.split(":");
  let durationString = "";
  if (duration[0] !== "00") {
    if (duration[0][0] === "0") {
      durationString = `${duration[0][1].toString()}${type === "long" ? " " : ""
        }${i18n.t(`${type}Hour`, {
          lng: localStorage.getItem("i18nextLng").substr(0, 2),
        }) + " "}`;
    } else {
      durationString = `${duration[0].toString()}${type === "long" ? " " : ""
        }${i18n.t(`${type}Hour`, {
          lng: localStorage.getItem("i18nextLng").substr(0, 2),
        })}`;
    }
  }
  if (duration[1] !== "00") {
    if (duration[1][0] === "0") {
      durationString = `${durationString + duration[1][1]}${type === "long" ? " " : ""
        }${i18n.t(`${type}Minute`, {
          lng: localStorage.getItem("i18nextLng").substr(0, 2),
        })}`;
    } else {
      durationString = `${durationString + " " + duration[1]}${type === "long" ? " " : ""
        }${i18n.t(`${type}Minute`, {
          lng: localStorage.getItem("i18nextLng").substr(0, 2),
        })}`;
    }
  }
  return durationString.trim();
};


const errorMessageNotification = (error) => {
  let _error = null;
  if (
    error &&
    error.data &&
    error.data.errors &&
    error.data.errors.length > 0
  ) {
    _error = error.data.errors[0].error;
  } else if (error && error.errors && error.errors.length > 0) {
    _error = error.errors[0].error;
  } else if (error && error.data && error.data.description) {
    _error = error.data.description;
  } else if (error && error.description) {
    _error = error.description;
  } else if (error) {
    _error = error;
  } else {
    _error = "Unknown error occured.";
  }

  return _error;
};

const copyToClipboard = str => {
  const el = document.createElement('textarea');
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  message.success('Kopyalandı!');
  document.body.removeChild(el);
};



export {
  getMinutesFromString,
  getHoursFromString,
  parseTimeSpanFromInteger,
  stringToDate,
  dateToString,
  isMobile,
  lowerFirstLetter,
  getDuration,
  goOtherWeek,
  errorMessageNotification,
  copyToClipboard
};



// WEBPACK FOOTER //
// ./src/helpers/methods.js